import { COLORS } from "../../../flowchart/utils/colors"

const ChartConfig = {
    chart: { 
      type: 'donut' 
    },
    series: [ 90, 10 ],
    labels: [ 'Eficiência', 'Perda' ],
    legend: { show: false },
    colors: [ 
      COLORS.BluePentagro1, 
      COLORS.OrangePentagro1 
    ],
    dataLabels: { 
      style: { 
        fontSize: '9px', 
        fontWeight: '300',
    }
  }
}

export default ChartConfig